export default "__VITE_ASSET__gTxdgYqT1FnWrjfbk9DrbA__";